import flat from 'array.prototype.flat';

if (!Array.prototype.flat) {
  flat.shim();
}
